import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss';
import Button from '../buttons/Button';
import formatPrice from '../../services/formatPrice';
import checkNaN from '../../services/checkNaN';

const LeasingRateBox = ( props ) => {
    let [ checkOne, setCheckOne ] = useState('Rata kwartalna (4 raty w roku)');
    let [ forceValidate, setForceValidate ] = useState(false);
    let [ load, setLoad ] = useState(false);
    let [ clickedButton, setClickedButton ] = useState(0);
    let [ price12, setPrice12 ] = useState(0);
    let [ price4, setPrice4 ] = useState(0);
    let [ errors, setErrors ] = useState(false);


    const dispatch = useDispatch()
    let rateFrequency        = useSelector(state => state.rateFrequency);
    let allowForm            = useSelector(state => state.allowForm);
    let rate                 = useSelector(state => state.rate);
    let finalRate            = useSelector(state => state.finalRate);
    let chargePrice          = useSelector(state => state.chargePrice)
    let tax                  = useSelector(state => state.tax); 
    let productPriceEnd      = useSelector(state => state.productPriceEnd); 
    let productPrice         = useSelector(state => state.productPrice); 
    let activeContract       = useSelector(state => state.selectedLease); 
    let partnerPromotionText = useSelector(state => state.partnerPromotionText);

    // useEffect(() => {
    //     console.log(rateFrequency)
    // }, [rateFrequency])
    // useEffect(() => {
    //     console.log(finalRate)
    // }, [finalRate])

    let validate = async () => {
        if ( checkOne.length === 0) {
            await setErrors(true);
        } else {
            await setErrors(false);
        }
    }

    useEffect(() => {
        if ( props.forceValidate ) {
            validate();
        }
    }, [props.forceValidate])

    useEffect(() => {
        if ( clickedButton > 0 ) {
            props.changePage();
        }
    }, [clickedButton])

    useEffect(() => {
        if ( (!load && rateFrequency.length > 0 && props.price4 > 0) || (!load && rateFrequency.length > 0 && props.price12 > 0)) {
            if ( rateFrequency == 'kwartalnie') {
                setCheckOne('Rata kwartalna (4 raty w roku)')
            }
            if ( rateFrequency == 'miesięcznie') {
                setCheckOne('Rata miesięczna (12 rat w roku)')
            }
            setLoad(true);
        }
        
    }, [load, rateFrequency, props.price4, props.price12])

    useEffect(() => {
        if ( checkOne.length > 0 ) {
            setForceValidate(false);
            setErrors(false);

            if(props.price4 > 0) {
                if ( checkOne == 'Rata kwartalna (4 raty w roku)' ) {
                    dispatch({ type: 'FINAL_RATE_CHANGE', value: props.price4 })
                    dispatch({ type: 'RATE_FREQUENCY_CHANGE', value: 'kwartalnie' })
                }
            }
            if(props.price12 > 0) {
                if ( checkOne == 'Rata miesięczna (12 rat w roku)' ) {
                    dispatch({ type: 'FINAL_RATE_CHANGE', value: props.price12 })
                    dispatch({ type: 'RATE_FREQUENCY_CHANGE', value: 'miesięcznie' })
                }
            }
        }
    }, [checkOne, props.price4, props.price12])
    return (
        <div className="leasing-rate-box">
            {partnerPromotionText && partnerPromotionText.length > 0 &&
                <p className='partner-promotion' dangerouslySetInnerHTML={ { __html: partnerPromotionText } } />
            }
            <p className={"leasing-head" + ( errors ? ' error-item':'')}>Wybierz interesującą Cię ratę</p>
            <div className="wrapper">
                    { rate.indexOf('kwartalna') > -1 &&
                        <>
                            { props.activeRate4 && 
                                <>
                                    <div className={"row rectangle-item" + ( checkOne === 'Rata kwartalna (4 raty w roku)' ? ' active': '') } onClick={ () => setCheckOne( 'Rata kwartalna (4 raty w roku)' ) }>
                                        <div className="text-rate">
                                            Kwartalna (4 raty w roku)
                                        </div>
                                        {props.price4 &&
                                            <div className="price">
                                                { checkNaN(formatPrice(props.price4)) } netto
                                            </div>
                                        }
                                    </div>
                                    <div className="pros">
                                        { (props.price12 * 12) == (props.price4 * 4) && 
                                            <p>
                                                WYGODNY OBIEG DOKUMENTÓW – TYLKO 4 FAKTURY W ROKU
                                            </p>
                                        }
                                       
                                        { (props.price12 * 12) > (props.price4 * 4) && ( (props.price12 * 12) - (props.price4 * 4) > 0 && (props.price12 * 12) - (props.price4 * 4) < 100 ) &&
                                            <p>
                                                WYGODNY OBIEG DOKUMENTÓW – TYLKO 4 FAKTURY W ROKU
                                            </p>
                                        }
                                        { (props.price12 * 12) > (props.price4 * 4) && ( (props.price12 * 12) - (props.price4 * 4) > 0 && (props.price12 * 12) - (props.price4 * 4) > 100 ) &&
                                            <p>
                                                OSZCZĘDNOŚCI RAT DO <b>{checkNaN(formatPrice(12 * props.price12 - 4 * props.price4))} </b> NETTO ROCZNIE – TYLKO 4 FAKTURY W ROKU
                                            </p>
                                        }
                                    </div>
                                </>
                            }
                        </>
                    }
                    
                    { rate.indexOf('miesieczna') > -1 &&
                        <>
                            <div className={"row rectangle-item" + ( checkOne === 'Rata miesięczna (12 rat w roku)' ? ' active': '') } onClick={ () =>  setCheckOne( 'Rata miesięczna (12 rat w roku)' ) }>
                                <div className="text-rate">
                                    Miesięczna (12 rat w roku)
                                </div>
                                {props.price12 &&
                                    <div className="price">
                                        { checkNaN(formatPrice(props.price12)) } netto
                                    </div>
                                }
                            </div>
                            
                        </>
                    }

                    <div className="values">
                        {/* <div className="value">
                            <p>Wartość przedmiotu:</p>
                            <p>
                                { checkNaN(formatPrice(productPrice)) } netto
                            </p>
                        </div> */}
                        <div className="value">
                            <> 
                                { tax != '0,00 zł' &&
                                    <>
                                        <p>Opłata za opracowanie:</p>
                                        <p>{ tax } netto</p>
                                    </>
                                }
                                
                            </>
                        </div>
                        {/* { tax && tax > 0 && */}
                            <div className="value">
                                <p>Opłata początkowa:</p>
                                <p>{ chargePrice } netto</p>
                            </div>
                        {/* } */}
                        {activeContract == "tradycyjny" &&
                            <div className="value">
                                <p>Wartość końcowa:</p>
                                <p>{  allowForm && !( checkNaN(formatPrice(props.price12)) != '0,00 zł' && !checkNaN(formatPrice(props.price4)) != '0,00 zł' ) ?  '0,00 zł' : productPriceEnd } netto</p>
                            </div>
                        }
                        { tax == '0,00 zł' &&
                            <p className='big-text'>Opłata za opracowanie 0 zł</p>
                        }
                    </div>

                    

                    <div className="texta">{ props.text }</div>
                    {/* { !allowForm && !( checkNaN(formatPrice(props.price12)) != '0,00 zł' && !checkNaN(formatPrice(props.price4)) != '0,00 zł' ) && 
                        <div className="texta red error-item">Parametry nieobsługiwane dla tego rodzaju sprzętu. Skontaktuj się z GRENKE.</div>
                    } */}
                    
                    {/* { allowForm  && 
                        <div className="buttons-wrap">
                            <Button title="Wypełnij wniosek online" 
                                    class="blue" 
                                    arrow={ true } 
                                    setFunction={ async () => { await setClickedButton(++clickedButton); } } />
                        </div>
                    } */}
                    { allowForm && !( checkNaN(formatPrice(props.price12)) != '0,00 zł' && !checkNaN(formatPrice(props.price4)) != '0,00 zł' ) && 
                        <div className="texta red error-item">Parametry nieobsługiwane dla tego rodzaju sprzętu lub kwoty. Skontaktuj się z GRENKE.</div>
                    }
                    
                    { allowForm && ( checkNaN(formatPrice(props.price12)) != '0,00 zł' && checkNaN(formatPrice(props.price4)) != '0,00 zł' ) &&  
                        <div className="buttons-wrap">
                            {/* <Button title="Powórt" class="reverse blue border-white" arrowPrev={ true } /> */}
                            <Button title="Wypełnij wniosek online" 
                                    // disabled={ !checkOne || !checkOne.length === 0 }
                                    class="blue" 
                                    arrow={ true } 
                                    setFunction={ async () => { await setClickedButton(++clickedButton); } } />
                        </div>
                    }
            </div>
        </div>
    )
}

export default LeasingRateBox;